module.exports = __webpack_public_path__ + "img/HU10011953.81f9630a.png";